export default __webpack_public_path__ + "images/ReportLogo.ad011a9493932fa55aad81caf9108da4.png";